import { useEffect } from 'react'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { safeStorage } from '@/lib/storage'

export type ThemePreference = 'system' | 'light' | 'dark'
export const THEME_STORAGE_KEY = 'leazepro.theme'

interface ThemeState {
  preference: ThemePreference
  setPreference: (p: ThemePreference) => void
}

/** Light / dark / system, kept per browser. `system` leaves it to `prefers-color-scheme` (globals.css). */
export const useThemeStore = create<ThemeState>()(
  persist((set) => ({ preference: 'system', setPreference: (preference) => set({ preference }) }), { name: THEME_STORAGE_KEY, storage: createJSONStorage(() => safeStorage) }),
)

export function applyTheme(preference: ThemePreference, root: HTMLElement = document.documentElement) {
  if (preference === 'system') root.removeAttribute('data-theme')
  else root.setAttribute('data-theme', preference)
}

/** Mount once at the app root: applies the stored preference and follows changes. */
export function useThemeEffect() {
  const preference = useThemeStore((s) => s.preference)
  useEffect(() => applyTheme(preference), [preference])
}
